import { render, staticRenderFns } from "./WalletParent.vue?vue&type=template&id=1cf60c7a&scoped=true"
import script from "./WalletParent.vue?vue&type=script&lang=js"
export * from "./WalletParent.vue?vue&type=script&lang=js"
import style0 from "./WalletParent.vue?vue&type=style&index=0&id=1cf60c7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf60c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf60c7a')) {
      api.createRecord('1cf60c7a', component.options)
    } else {
      api.reload('1cf60c7a', component.options)
    }
    module.hot.accept("./WalletParent.vue?vue&type=template&id=1cf60c7a&scoped=true", function () {
      api.rerender('1cf60c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Wallet/WalletParent.vue"
export default component.exports